import {
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILURE,
} from "../actions/actionTypes";
import apiClient from "../../utils/apiClient";


export const validateOtpThunk = ( otp, uniqueId, verificationMethod ) => {
  return async (dispatch) => {
    dispatch({ type: VALIDATE_OTP_REQUEST });
    let errorData = "";

    try {
      const response = await apiClient.post(
        "/validateOtp",
        { otp, uniqueId, verificationMethod }
      );

      const data = response.data;

      
      dispatch({ type: VALIDATE_OTP_SUCCESS, payload: data });

    } catch (error) {
      errorData = error.response?.data || errorData;
      dispatch({
        type: VALIDATE_OTP_FAILURE,
        payload:
          // error.message + " (Details: " + (errorData?.message || "Unknown error details") + ")"
          (errorData || "Unknown error details")
      });
    }
  };
};
